import * as React from "react";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { VirtualAgentControlState } from "@shared-ui/customer-virtual-agent-control";
import { TripsHeroStateChunk } from "../../flexComponents/TripsOverviewHero/state/TripsHeroState";

const StateProvider = buildStateProvider(new TripsHeroStateChunk(), new VirtualAgentControlState());

export const ProvidedStateWrapper: React.FC = ({ children }) => {
  return <StateProvider>{children}</StateProvider>;
};
